import { config } from '../../utils/utils';
import store from '../../store';
import { toastHandler } from '../../utils/toastHandler';

export interface LicenseExpirationAlert {
  id: string;
  title: string;
  message: string;
  expirationDate: string | null;
  daysRemaining: number | null;
  isExpired: boolean;
  gracePeriodDaysRemaining: number | null;
  licenseId: string | null;
  createdAt: string;
}

export interface LicenseExpirationAlertResponse {
  hasAlert: boolean;
  alert: LicenseExpirationAlert | null;
}

/**
 * Fetch license expiration alert for the logged-in company user
 * @returns Promise with alert data
 */
export const fetchLicenseExpirationAlert = async (): Promise<LicenseExpirationAlertResponse> => {
  try {
    const { accessToken } = store.getState().auth;

    const response = await fetch(`${config.BASE_URL}/license-expiration-alert`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`,
      },
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Failed to fetch license expiration alert');
    }

    return await response.json();
  } catch (error: any) {
    toastHandler(error);
    throw error;
  }
};

